import React, { useState } from 'react'
import ModalAgregarSuministrosPaquetesQx from './ModalAgregarSuministrosPaquetesQx'
import { postInsertPaqueteYSuministros } from '../../../services/Clinico'
import ModalErrorSuministrosRepetidos from './ModalErrorSuministrosRepetidos'
import ModalPaquetesQxGuardados from './ModalPaquetesQxGuardados'

const ModalCrearMaestroPaquetesQx = ({setmodalOnCrearPaquetesQx, setactuliazarDataPaqueteQx}) => {
    const [modalOnSuministros, setmodalOnSuministros]=useState(false)
    const [dataListaSuministrosParaPaqueteQx, setdataListaSuministrosParaPaqueteQx]=useState([])
    const [errorCodigoPaquete, seterrorCodigoPaquete]=useState('Seleccionar Codigo Paquete')
    const [errorSeleccionarDescripcion, seterrorSeleccionarDescripcion]=useState('Seleccionar una descripción')
    const [errorSuministrosRepetidos, seterrorSuministrosRepetidos]=useState({
      "suministrosRepetidos":'',
      'paquetesRepetidos':''
    })
    const [modalOnSuministrosRepetidos, setmodalOnSuministrosRepetidos]=useState(false)
    const [modalOnInformacionCorrectamente, setmodalOnInformacionCorrectamente]=useState(false)
    const [isPaqueteGenerico, setisPaqueteGenerico]=useState(true)
    const [loading, setloading]=useState(true)

    const handleCancelarClick=()=>{
        setmodalOnCrearPaquetesQx(false)
    }
    const handleOnClickAgregar=()=>{
        setmodalOnSuministros(true)
    }

    function tieneValorDuplicado(arr) {
      const visto = new Set();
      for (const item of arr) {
        if (visto.has(item.MSRESO)) {
          return true; // Encontramos un duplicado
        }
        visto.add(item.MSRESO);
      }
      return false; // No se encontraron duplicados
    }

    const handleSubmitGuardarSuministrosYPaquete=(e)=>{
      e.preventDefault()

      const insertar={
        'PaqCod': e.target.codigo.value,
        'PaqDes': e.target.descripcion.value,
        'PaqTip': e.target.tipoPaquete.value,
        'PaqInd': e.target.indicador.value,
        'PaqIndAct': e.target.activo.value,
        'suministros': dataListaSuministrosParaPaqueteQx
      }
      const validarRepetido = tieneValorDuplicado(dataListaSuministrosParaPaqueteQx)
      
      if(validarRepetido){         
        seterrorSuministrosRepetidos({          
          suministrosRepetidos: 'Los suministros estan repetidos, por favor validar!',
          paquetesRepetidos:''
        });      
        setmodalOnSuministrosRepetidos(true)
      }else{
        seterrorSuministrosRepetidos('')
        if(errorSeleccionarDescripcion === '' && errorCodigoPaquete === ''){
          setloading(false)
          postInsertPaqueteYSuministros(insertar).then((res)=>{  
            //console.log(res.data, 'insert paquete y suministros')
            setloading(true)
            if(res.data.success){
              setmodalOnInformacionCorrectamente(true)
              setactuliazarDataPaqueteQx(insertar)
            }else{
              seterrorSuministrosRepetidos({
                suministrosRepetidos:'', 
                paquetesRepetidos: res.data.message
              });
              setmodalOnSuministrosRepetidos(true)
            }
          })
        }
      }
      
      
    }

    const handleOnchangeCodigo=(e)=>{
      if(e.target.value.trim()){
        seterrorCodigoPaquete('')
      }else{
        seterrorCodigoPaquete('Seleccionar Codigo Paquete')
      }
    }

    const handleOnchangeDescripcion=(e)=>{
      if(e.target.value.trim()){
        seterrorSeleccionarDescripcion('')
      }else{
        seterrorSeleccionarDescripcion('Seleccionar una descripción')
      }
    }

    const handleClickEliminar=(indexEliminar)=>{
      setdataListaSuministrosParaPaqueteQx(eliminarUnaFormaLiquidar =>
        eliminarUnaFormaLiquidar.filter((_, index) => index !== indexEliminar)
      );
    }

    const handleOnchangeIndicador=(e)=>{
      if(e.target.value === 'G'){
        setisPaqueteGenerico(false)
        setdataListaSuministrosParaPaqueteQx([])
      }else{
        setisPaqueteGenerico(true)
      }
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-full  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Creación de Paquetes
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            <form onSubmit={handleSubmitGuardarSuministrosYPaquete}>
              <div className="flex  text-left">
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Código Paquete
                  </label>
                  <div className="flex">
                    <input
                      type="text"
                      name="codigo"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      onChange={handleOnchangeCodigo}
                    />
                    
                  </div>
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorCodigoPaquete}
                  </label>
                </div>
                <div className="w-2/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Descripción Paquete
                  </label>
                  <div className="flex">
                    <input                      
                      name="descripcion"
                      type="text"
                      autoComplete="off"
                      className="form-control block w-full px-3 py-1 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                      onChange={handleOnchangeDescripcion}
                    />
                  </div>
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarDescripcion}
                  </label>
                </div>
               
              </div>
              <div className="flex  text-left mb-3">
                
                
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Tipo Paquete
                  </label>
                  <div className="flex">
                  
                  <select          
                    //onChange={handleOnchangeCaracteristica}          
                    className="form-select block  w-full px-3 py-1 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='tipoPaquete'
                  >
                    <option value="Q">Quirurgicos</option>
                    <option value="N">No Quirurgicos</option>                    
                  </select>
                
                    
                  </div>
                </div>
                <div className="w-1/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Indicador
                  </label>
                  <div className="flex">
                  
                  <select          
                    onChange={handleOnchangeIndicador}          
                    className="form-select block  w-full px-3 py-1 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='indicador'
                  >
                    <option value="P">Paquetes</option>
                    <option value="G">Generico</option>                    
                  </select>
                
                    
                  </div>
                </div>
                <div className="w-1/3  px-4 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                   Activo
                  </label>
                  <div className="flex">
                  
                  <select          
                    //onChange={handleOnchangeCaracteristica}          
                    className="form-select block  w-full px-3 py-1 text-base font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    aria-label="Default select example"
                    name='activo'
                  >
                    <option value="S">Activo</option>
                    <option value="N">Inactivo</option>                    
                  </select>
               
                    
                  </div>
                </div>
              </div>
              
                {
                  isPaqueteGenerico &&
                  <div className="flex  text-left p-4">
                    <button
                  onClick={handleOnClickAgregar}
                  type="button"
                  className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Agregar Suministros
                </button>
                </div>
                }
              
            {
              isPaqueteGenerico &&
              <div className="flex flex-col">
              <div className="overflow-x-auto ">
                <div className="py-2 inline-block min-w-full sm:px-3 ">
                  <div className="overflow-hidden">
                    <table className="min-w-full text-center">
                      <thead className="border-b bg-gray-200">
                        <tr>
                          <th></th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Producto
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Comercial
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Cantidad
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Generico
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Concentración
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Marca
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                           Indicador
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Activo
                          </th>
                          <th
                            scope="col"
                            className="text-sm font-medium text-gray-900 px-3 py-2"
                          >
                            Forma
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          dataListaSuministrosParaPaqueteQx.map((item,index)=>(
                            <tr className=" divide-y divide-slate-700 " key={index}>
                              <td></td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                <button
                                  onClick={()=>handleClickEliminar(index)}
                                  type="button"
                                  className="inline-block px-2 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
                                >
                                  Eliminar
                                </button>
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.MSRESO}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                                {item.MSNomG}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.PaqCant}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                                {item.MSDesc}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                                {item.CncDes}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                                {item.MarDsc}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.PaqFac === 'F'? 'Facturable':'Hoja de gasto'}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
                                {item.PaqAct === 'S'? 'Si':'No'}
                              </td>
                              <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">
                                {item.FSmDscUMd}
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>                      
                    </table>
                  </div>
                </div>
              </div>
            </div>
            }
            
          
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button type="submit"
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Guardar
          </button>
          </div>
          </form>
          </div>
        </div>
      </div>
      {modalOnSuministros? <ModalAgregarSuministrosPaquetesQx setmodalOnSuministros={setmodalOnSuministros} setdataListaSuministrosParaPaqueteQx={setdataListaSuministrosParaPaqueteQx}/>:null}
      {modalOnSuministrosRepetidos? <ModalErrorSuministrosRepetidos setmodalOnSuministrosRepetidos={setmodalOnSuministrosRepetidos} errorSuministrosRepetidos={errorSuministrosRepetidos}/>:null}
      {modalOnInformacionCorrectamente? <ModalPaquetesQxGuardados setmodalOnInformacionCorrectamente={setmodalOnInformacionCorrectamente} setmodalOnCrearPaquetesQx={setmodalOnCrearPaquetesQx} setactuliazarDataPaqueteQx={setactuliazarDataPaqueteQx}/>:null}
      
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }
    </div>
  )
}

export default ModalCrearMaestroPaquetesQx